module.exports = __webpack_public_path__ + "media/images/icon-dots-52cc97c33d468180300ec8cd0e25746f.svg";